import * as React from 'react';
import { LocationTypes } from '~src/ts/models/ILocationInfo';
import { FeatureFlags } from '~src/ts/FeatureFlags';
import { BasicField } from './BasicField';
import { RelatedEntity } from './RelatedEntity';
import { Messages } from '~src/codegen/Localize';
import { EntityLinkProps } from './EntityLink';
import { imgPath } from '~src/common/utilities/ImgUrl';

export interface LocationFieldProps {
  locationType: LocationTypes;
  inProjectSpace: boolean;
  inPersonalSpace: boolean;
  projectLink?: EntityLinkProps;
}

export function LocationField(props: LocationFieldProps) {
  return (
  <>
     {!props.inPersonalSpace && props.locationType === LocationTypes.PersonalSpace &&
     <BasicField name={Messages.column_location()} value={Messages.personalSpaceGridLabel()}/> }
     {!props.inProjectSpace && props.locationType === LocationTypes.Project &&
     <RelatedEntity label={Messages.column_location()} link={props.projectLink} /> }
  </>
  );
}
